export default {
    "et": {
        "kontakt": "KONTAKT",
        "hinnakiri": "HINNAKIRI",
        "tingimused": "TINGIMUSED",
        "Noustun tingimustega": "Nõustun tingimustega",
        "Privaatsuspoliitika": "Privaatsuspoliitika",
        "Tingimusetega peab noustuma": "Kuulutuse avaldamiseks on vajalik nõustuda tingimustega",
        "Maksmine": "Maksmine",
        "Vaata ule hinna kujunemine ja vali maksevahend": "Vaata üle maksumuse kujunemine ja vali makseviis",
        "Tuup": "Tüüp",
        "Valjaanne": "Väljaanne",
        "Hind": "Hind",
        "Kogus": "Kogus",
        "Summa": "Summa",
        "Kaibemaks": "Käibemaks",
        "Vali maksevahend": "Vali makseviis",
        "advertisement": "Kuulutus",
        "greeting": "Õnnitlus",
        "condolence": "Kaastundeavaldus või leinateade",
        "Maksa mobiiliga": "Maksa mobiiliga",
        "Maksa arve alusel": "Kinnitan, et maksan arve alusel",
        "Valjaanded": "Väljaanded",
        "Millistes lehtedes soovid kuulutust avaldada": "Millistes lehtedes soovid kuulutust avaldada",
        "Vali koik": "Vali kõik",
        "Liigu edasi": "EDASI",
        "Tellija": "Tellija",
        "Sisu": "Sisu",
        "Ilmumine": "Ilmumine",
        "Maksmine 2": "Maksmine",
        "Vali millal kuulutus ilmuma peaks": "Vali, millal kuulutus ilmuma peaks",
        "Jargmine ilmumine": "Järgmine ilmumine",
        "Jargmised 5 ilmumist": "Järgmised 5 ilmumist",
        "Jargmised 10 ilmumist": "Järgmised 10 ilmumist",
        "Lisa valjaanne": "Lisa väljaanne",
        "Kuulutuse tuup": "Kuulutuse tüüp",
        "Vali millist tuupi kuulutust soovid avaldada": "Vali, millist tüüpi kuulutust soovid avaldada",
        "Sisesta onnitluse sisu": "Sisesta õnnitluse sisu",
        "Onnitletava nimi": "Õnnitletava nimi",
        "Alguse tekst": "Alguse tekst",
        "popover onnitlus nimi": "Kirjuta siia inimese nimi, keda soovid õnnitleda.",
        "popover onnitlus algusetekst": "Sisesta siia tekst, mida soovid kuvada enne õnnitletava nime.",
        "Lopu tekst": "Lisa tekst, mida soovid kuvada peale nime.",
        "popover onnitlus loputekst": "Lisa siia tekst, mida soovid kuvada peale õnnitletava nime",
        "Luuletus": "Luuletus",
        "popover onnitlus luuletus": "Soovikorral lisa siia luuletus, mida soovid õnnitluseks kasutada või vali meie andmebaasist sobiv.",
        "Vali olemasolev luuletus": "Vali olemasolev luuletus",
        "Pilt voi sumbol": "Pilt või sümbol",
        "popover onnitlus pilt symbol": "Soovikorral vali pilt või sümbol, mida soovid õnnitlusele lisada",
        "Lae pilt oma arvutist": "Lae pilt oma arvutist",
        "Sisesta kaastundeavalduse sisu": "Sisesta kaastundeavalduse sisu",
        "Lahkunu nimi": "Lahkunu nimi",
        "popover lahkunu nimi": "Kirjuta siia lahkunu nimi",
        "Sunnikuupaev": "Sünnikuupäev",
        "popover synniaeg": "Sünniaeg",
        "Lahkumiskuupaev": "Lahkumiskuupäev",
        "popover lahkumisaeg": "Kirjuta siia lahkunu surmakuupäev",
        "popover kaastunne algusetekst": "Kirjuta siia tekst, mis paigutatakse enne lahkunu nime.",
        "popover kaastunne loputekst": "Kirjuta siia tekst, mida soovid paigutada peale lahkunu nime ja sünni- ning surmakuupäeva.",
        "popover kaastunne luuletus": "Kui soovid lisada kaastundeavaldusele luuletuse, saad sisestada enda luuletuse või valida meie andmebaasist sobiva luuletuse.",
        "popover kaastunne pilt symbol": "Lisa kaastundeavaldusele pilt või sümbol, mida soovid kasutada.",
        "Tellija andmed": "Tellija andmed",
        "Sisesta tellija andmed": "Sisesta tellija andmed. * märgitud väljad on kohustuslikud",
        "Maksja tuup": "Maksja tüüp",
        "Eraisik": "Eraisik",
        "Juriidiline isik": "Juriidiline isik",
        "Nimi": "Nimi",
        "Registrikood": "Registrikood",
        "Telefoninumber": "Telefoninumber",
        "E posti aadress": "E-posti aadress",
        "Soovin saada soodustuspakkumisi emailile": "Soovin saada soodustuspakkumisi emailile",
        "erisoovid": "Erisoovide korral võta ühendust <a href=\"mailto:kuulutused{\'@\'}ohtulehtkirjastus.ee\">kuulutused{\'@\'}ohtulehtkirjastus.ee</a> või helista <a href=\"tel:+3726144100\">+372 614 4100</a>",
        "Laeb lehte": "Laeb lehte",
        "ALUSTA KUULUTUSE LISAMIST": "ALUSTA KUULUTUSE LISAMIST",
        "Eesti keel": "Eesti keel",
        "Vene keel": "Vene keel",
        "Inglise keel": "Inglise keel",
        "Sisesta kuulutuse sisu": "Sisesta kuulutuse sisu ja kontaktid",
        "Rubriik": "Rubriik",
        "Kuulutuse sisu": "Kuulutuse sisu",
        "popover rubriik": "Vali rubriik, milles soovid kuulutuse avaldada",
        "popover kuulutuse sisu": "Lisa siia tekst, mida soovid kuulutada",
        "Raam": "Raam",
        "popover raam": "Raami lisamine lisab kuulutuse iga ilmumise hinnale 2€.",
        "Taust": "Taust",
        "popover taust": "Tausta lisamine lisab ilmumise hinnale 2€.",
        "Pilt": "Pilt",
        "popover pilt": "Pildi lisamine lisab iga ilmumise hinnale 10 €.",
        "Telli tolge": "Telli tõlge",
        "popover tellitolge": "Telli kuulutuse tõlkimine",
        "Tolge vene keeles": "Tõlge vene keeles",
        "Tolge inglise keeles": "Tõlge inglise keeles",
        "Tolge eesti keeles": "Tõlge eesti keeles",
        "Kokku": "Kokku",
        "Aitah tellimus on esitatud": "Aitäh, tellimus on esitatud!",
        "Kusimuste korral helista": "Küsimuste korral helista",
        "voi kirjuta": "või kirjuta",
        "Sisesta veel kuulutusi": "Sisesta veel kuulutusi",
        "Ohtulehte uudiseid lugema": "Õhtulehte uudiseid lugema",
        "Sessioon on aegunud sisesta kuulutus uuesti": "Sessioon on aegunud, palun sisesta kuulutus uuesti!",
        "captcha_failed": "Palun värskenda lehte ja proovi uuesti. Google arvab, et sa oled robot.",
        "Kuulutuste hinnakirja vaata SIIT": "Kuulutuste hinnakirja vaata SIIT",
        "Makse ebaonnestus": "Makse ebaõnnestus",
        "Arasaatmine": "Ärasaatmine",
        "popover arasaatmine": "Ärasaatmine",
        "Maksmine voimatu": "Tehnilise vea tõttu pole hetkel võimalik maksta!"
    },
    "en": {
        "kontakt": "CONTACT",
        "hinnakiri": "PRICELIST",
        "tingimused": "TERMS",
        "Noustun tingimustega": "I agree with terms and conditions",
        "Privaatsuspoliitika": "Privacy policy",
        "Tingimusetega peab noustuma": "You need to agree with terms and conditions to publish the advertisement",
        "Maksmine": "Payment",
        "Vaata ule hinna kujunemine ja vali maksevahend": "Review the order details and choos payment method",
        "Tuup": "Type",
        "Valjaanne": "Publication",
        "Hind": "Price",
        "Kogus": "Amount",
        "Summa": "Total",
        "Kaibemaks": "VAT",
        "Vali maksevahend": "Choose payment option",
        "advertisement": "Advertisement",
        "greeting": "Congratulation",
        "condolence": "Condolence",
        "Maksa mobiiliga": "Pay by mobile",
        "Maksa arve alusel": "I confirm that I will pay by an invoice",
        "Valjaanded": "Publications",
        "Millistes lehtedes soovid kuulutust avaldada": "Choose publications where to publish your advertisement",
        "Vali koik": "Choose all",
        "Liigu edasi": "NEXT",
        "Tellija": "Client",
        "Sisu": "Content",
        "Ilmumine": "Dates of publication",
        "Maksmine 2": "Payment",
        "Vali millal kuulutus ilmuma peaks": "Choose when to publish the advertisement",
        "Jargmine ilmumine": "Next issue",
        "Jargmised 5 ilmumist": "Next 5 issues",
        "Jargmised 10 ilmumist": "Next 10 issues",
        "Lisa valjaanne": "Add publication",
        "Kuulutuse tuup": "Advertisement type",
        "Vali millist tuupi kuulutust soovid avaldada": "Choose advertisement type",
        "Sisesta onnitluse sisu": "Insert congratulations content",
        "Onnitletava nimi": "Name",
        "Alguse tekst": "Start text",
        "popover onnitlus nimi": "The name of the person being congratulated",
        "popover onnitlus algusetekst": "Insert here the text you wish to be placed before the name of the person being congratulated",
        "Lopu tekst": "Insert the text used after the name",
        "popover onnitlus loputekst": "Insert the text you wish to use after the name of the person being congratulated",
        "Luuletus": "Poem",
        "popover onnitlus luuletus": "If you wish, add here the poem you wish to use with the congratulation or choose one from our database.",
        "Vali olemasolev luuletus": "Choose a poem",
        "Pilt voi sumbol": "Image or symbol",
        "popover onnitlus pilt symbol": "If you wish, choose the image or symbol to add to the congratulation",
        "Lae pilt oma arvutist": "Upload image",
        "Sisesta kaastundeavalduse sisu": "Insert the content of the condolence",
        "Lahkunu nimi": "Name of the deceased",
        "popover lahkunu nimi": "Write here the name of the deceased",
        "Sunnikuupaev": "Date of birth",
        "popover synniaeg": "Date of birth",
        "Lahkumiskuupaev": "Date of death",
        "popover lahkumisaeg": "Add the date of death",
        "popover kaastunne algusetekst": "Please write here the text placed above the name of the deceased.",
        "popover kaastunne loputekst": "Insert the text you wish to use below the name and date of birth and death.",
        "popover kaastunne luuletus": "If you wish to add a poem to the condolence, you can insert your own or choose from our database",
        "popover kaastunne pilt symbol": "Please add the image or symbol you wish to use with the condolence ",
        "Tellija andmed": "Client details",
        "Sisesta tellija andmed": "Insert client details. * marked fields are required.",
        "Maksja tuup": "Client type",
        "Eraisik": "Private person",
        "Juriidiline isik": "Company",
        "Nimi": "Name",
        "Registrikood": "Registration code",
        "Telefoninumber": "Phone",
        "E posti aadress": "Email",
        "Soovin saada soodustuspakkumisi emailile": "I would like to get special offers via email",
        "erisoovid": "With special requests, please contact us at <a href=\"mailto:kuulutused{\'@\'}ohtulehtkirjastus.ee\">kuulutused{\'@\'}ohtulehtkirjastus.ee</a> or call <a href=\"tel:+3726144100\">+372 614 4100</a>",
        "Laeb lehte": "Loading the page",
        "ALUSTA KUULUTUSE LISAMIST": "START INSERTING THE ADVERTISMENT",
        "Eesti keel": "Estonian",
        "Vene keel": "Russian",
        "Inglise keel": "English",
        "Sisesta kuulutuse sisu": "Insert the text of advertisement",
        "Rubriik": "Section",
        "Kuulutuse sisu": "Advertisement text",
        "popover rubriik": "Please select the section of the advertisement",
        "popover kuulutuse sisu": "Write here the text of advertisement",
        "Raam": "Frame",
        "popover raam": "Adding a frame costs an extra of 2€",
        "Taust": "Background",
        "popover taust": "Adding a background costs an extra of 2€",
        "Pilt": "Image",
        "popover pilt": "Adding an image costs an extra of 10€",
        "Telli tolge": "Order translation",
        "popover tellitolge": "Order translation of the advertisement",
        "Tolge vene keeles": "Russian translation",
        "Tolge inglise keeles": "English translation",
        "Tolge eesti keeles": "Estonian translation",
        "Kokku": "Total",
        "Aitah tellimus on esitatud": "Thank you! Your order has been submitted.",
        "Kusimuste korral helista": "In case of questions, please call",
        "voi kirjuta": "or write",
        "Sisesta veel kuulutusi": "Insert another advertisement",
        "Ohtulehte uudiseid lugema": "To Õhtuleht",
        "Sessioon on aegunud sisesta kuulutus uuesti": "Session has expired, please insert your advertisement again.",
        "captcha_failed": "Please refresh the page and try again. Google thinks that you are a robot.",
        "Kuulutuste hinnakirja vaata SIIT": "Check advertisement prices from HERE",
        "Makse ebaonnestus": "Payment failed",
        "Arasaatmine": "Funeral",
        "popover arasaatmine": "Funeral",
        "Maksmine voimatu": "Due to a technical error, it is not possible to pay at the moment!"
    },
    "ru": {
        "kontakt": "КОНТАКТЫ",
        "hinnakiri": "ПРАЙС-ЛИСТ",
        "tingimused": "УСЛОВИЯ",
        "Noustun tingimustega": "Я согласен с условиями",
        "Privaatsuspoliitika": "Политика конфиденциальности",
        "Tingimusetega peab noustuma": "Вы должны согласиться с условиями, чтобы опубликовать объявление",
        "Maksmine": "Оплата",
        "Vaata ule hinna kujunemine ja vali maksevahend": "Просмотреть данные по оплате",
        "Tuup": "Тип",
        "Valjaanne": "Издание",
        "Hind": "Цена",
        "Kogus": "Количество",
        "Summa": "Сумма",
        "Kaibemaks": "Налог с оборота",
        "Vali maksevahend": "Выберите тип оплаты",
        "advertisement": "Объявление",
        "greeting": "Поздравление",
        "condolence": "Соболезнование",
        "Maksa mobiiliga": "Мобильный платёж",
        "Maksa arve alusel": "Я подтверждаю, что я буду платить по счету",
        "Valjaanded": "Издания",
        "Millistes lehtedes soovid kuulutust avaldada": "В каких изданиях опубликовать объявление",
        "Vali koik": "Выбрать всё",
        "Liigu edasi": "ДАЛЕЕ",
        "Tellija": "Заказчик",
        "Sisu": "Содержание",
        "Ilmumine": "Публикация",
        "Maksmine 2": "Оплата",
        "Vali millal kuulutus ilmuma peaks": "Когда опубликовать объявление?",
        "Jargmine ilmumine": "Следующая публикация",
        "Jargmised 5 ilmumist": "Следующие 5 публикаций",
        "Jargmised 10 ilmumist": "Следующие 10 публикаций",
        "Lisa valjaanne": "Добавить издание",
        "Kuulutuse tuup": "Тип объявления",
        "Vali millist tuupi kuulutust soovid avaldada": "Выберите тип объявления",
        "Sisesta onnitluse sisu": "Введите текст поздравления",
        "Onnitletava nimi": "Имя поздравляемого",
        "Alguse tekst": "Начало текста",
        "popover onnitlus nimi": "Введите имя человека, которого желаете поздравить.",
        "popover onnitlus algusetekst": "Введите текст, который будет отображен перед именем поздравляемого.",
        "Lopu tekst": "Введите текст, который будет отображен после имени.",
        "popover onnitlus loputekst": "Текст",
        "Luuletus": "Стихотворение",
        "popover onnitlus luuletus": "При желании добавьте стихотворение, которое хотите использовать в поздравлении, или выберите подходящее в нашей базе данных.",
        "Vali olemasolev luuletus": "Выберите стихотворение",
        "Pilt voi sumbol": "Фото или символ",
        "popover onnitlus pilt symbol": "При желании добавьте фотографию или символ, который хотите использовать",
        "Lae pilt oma arvutist": "Загрузить фото с компьютера",
        "Sisesta kaastundeavalduse sisu": "Введите текст соболезнования",
        "Lahkunu nimi": "Имя покойного",
        "popover lahkunu nimi": "Введите имя покойного",
        "Sunnikuupaev": "День рождения",
        "popover synniaeg": "Дата рождения",
        "Lahkumiskuupaev": "Дата смерти",
        "popover lahkumisaeg": "Введите дату смерти усопшего",
        "popover kaastunne algusetekst": "Введите текст, который будет размещен перед именем усопшего.",
        "popover kaastunne loputekst": "Введите текст, который хотите добавить вдобавок к имени и датам рождения и смерти усопшего.",
        "popover kaastunne luuletus": "Если хотите добавить к объявлению стихотворение, то можете ввести свое стихотворение или выбрать подходящее из нашей базы данных.",
        "popover kaastunne pilt symbol": "Добавьте к объявлению фотографию или символ, который хотите использовать",
        "Tellija andmed": "Данные заказчика",
        "Sisesta tellija andmed": "Заполните данные заказчика. * отмеченные поля обязательны для заполнения",
        "Maksja tuup": "Тип заказчика",
        "Eraisik": "Частное лицо",
        "Juriidiline isik": "Юридическое лицо",
        "Nimi": "Имя",
        "Registrikood": "Регистрационный номер\n",
        "Telefoninumber": "Номер телефона",
        "E posti aadress": "Электронная почта",
        "Soovin saada soodustuspakkumisi emailile": "Желаю получать выгодные предложения по электронной почте",
        "erisoovid": "По дополнительным вопросам свяжитесь с нами: <a href=\"mailto:kuulutused{\'@\'}ohtulehtkirjastus.ee\">kuulutused{\'@\'}ohtulehtkirjastus.ee</a> или по телефону <a href=\"tel:+3726144100\">+372 614 4100</a>",
        "Laeb lehte": "Загрузка",
        "ALUSTA KUULUTUSE LISAMIST": "НАЧАТЬ ДОБАВЛЕНИЕ ОБЪЯВЛЕНИЯ",
        "Eesti keel": "Эстонский язык",
        "Vene keel": "Русский язык",
        "Inglise keel": "Английский язык",
        "Sisesta kuulutuse sisu": "Введите текст объявления",
        "Rubriik": "Рубрика",
        "Kuulutuse sisu": "Текст объявления",
        "popover rubriik": "Выберите рубрику, в которую хотите добавить объявление",
        "popover kuulutuse sisu": "Текст объявления",
        "Raam": "Рамка",
        "popover raam": "Добавление рамки объявления стоит 2€.",
        "Taust": "Фон",
        "popover taust": "Добавление фона объявления стоит 2€.",
        "Pilt": "Фотография",
        "popover pilt": "Добавление фотографии стоит 10 €.",
        "Telli tolge": "Заказать перевод",
        "popover tellitolge": "Заказать перевод объявления",
        "Tolge vene keeles": "Русский перевод",
        "Tolge inglise keeles": "Английский перевод",
        "Tolge eesti keeles": "Эстонский перевод",
        "Kokku": "Итого",
        "Aitah tellimus on esitatud": "Спасибо, ваш заказ принят!",
        "Kusimuste korral helista": "По всем вопросам звоните",
        "voi kirjuta": "или напишите",
        "Sisesta veel kuulutusi": "Новое объявление",
        "Ohtulehte uudiseid lugema": "Читать Õhtuleht",
        "Sessioon on aegunud sisesta kuulutus uuesti": "Сессия устарела, пожалуйста заново заполните форму объявления.",
        "captcha_failed": "Обновите страницу и попробуйте снова. Google думает, что вы робот.",
        "Kuulutuste hinnakirja vaata SIIT": "Проверьте цены на рекламу ЗДЕСЬ",
        "Makse ebaonnestus": "Платеж не прошел",
        "Arasaatmine": "Прощание с покойным",
        "popover arasaatmine": "Прощание с покойным",
        "Maksmine voimatu": "Из-за технической ошибки в данный момент оплатить невозможно!"
    }
};
